<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マーク検索条件設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">マーク名</label>
            <div class="list-input-content">
              <app-text-input id="txt_MarkName" #txt_MarkName [subid]="'txt_MarkName'" [forcedEnabledMode]="'true'"
                [restrict]="'[ -￮]'" [maxChars]="25" [tabindex]="0" [editable]="true" [displayCountField]="false"
                [(ngModel)]="kymw1501Model.markName" [style.width.px]="380">
              </app-text-input>
            </div>

            <label class="list-input-title">マークファイル名</label>
            <div class="list-input-content">
              <app-text-input id="txt_MarkFileName" #txt_MarkFileName [subid]="'txt_MarkFileName'"
                [forcedEnabledMode]="'true'" [restrict]="'[ -￮]'" [maxChars]="6" [tabindex]="0" [editable]="true"
                [displayCountField]="false" [halfOnly]="true" [(ngModel)]="kymw1501Model.markFileName"
                style="width:5rem;" (input)="eventMarkFileName_deleteCommaHandler()"
                (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
              </app-text-input>
            </div>

            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <select id="cmb_MarkGroup" #cmb_MarkGroup [tabindex]="0" [(ngModel)]="kymw1501Model.markGroupCode"
                forcedEnabledMode="true" [style.width.px]="200">
                <ng-template ngFor let-item [ngForOf]="kymw1501Model.kymw1501InputVO.markGroupList">
                  <option value="{{item.MarkGroupCode}}">{{item.Caption}}</option>
                </ng-template>
              </select>
            </div>

            <label class="list-input-title">マーク区分</label>
            <div class="list-input-content">
              <select id="cmb_SupplyPromoteMarkDiv" #cmb_SupplyPromoteMarkDiv [tabindex]="0" forcedEnabledMode="true"
                [(ngModel)]="kymw1501Model.supplyPromoteMarkDiv" [style.width.px]="200">
                <ng-template ngFor let-item [ngForOf]="kymw1501Model.kymw1501InputVO.supplyPromoteMarkDivList">
                  <option value="{{item.CodeValue}}">{{item.CodeName}}</option>
                </ng-template>
              </select>
            </div>

            <label class="list-input-title">マーク名登録日</label>
            <div class="list-input-content">
              <wj-input-date #dtf_RegistMarkDateFrom id="dtf_RegistMarkDateFrom" format="yyyy/MM/dd"
                forcedEnabledMode="true" [isRequired]="false" [min]="minDate" [max]="maxDate"
                [(text)]="kymw1501Model.registMarkDateFrom" [tabindex]="0"></wj-input-date>
              <label>～</label>
              <wj-input-date #dtf_RegistMarkDateTo id="dtf_RegistMarkDateTo" format="yyyy/MM/dd"
                forcedEnabledMode="true" [isRequired]="false" [min]="minDate" [max]="maxDate"
                [(text)]="kymw1501Model.registMarkDateTo" [tabindex]="0"></wj-input-date>
              <button class="btn-tartiary" id="btn_RegistMarkDateClear"
                (click)="eventRegistMarkDateClear_CLICKHandler()" forcedEnabledMode="true" [tabindex]="0">クリア</button>
            </div>

            <label class="list-input-title">マークファイル登録日</label>
            <div class="list-input-content">
              <wj-input-date #dtf_FileRegistDateFrom id="dtf_FileRegistDateFrom" format="yyyy/MM/dd"
                forcedEnabledMode="true" [isRequired]="false" [min]="minDate" [max]="maxDate"
                [(text)]="kymw1501Model.fileRegistDateFrom" [tabindex]="0"></wj-input-date>
              <label>～</label>
              <wj-input-date #dtf_FileRegistDateTo id="dtf_FileRegistDateTo" format="yyyy/MM/dd"
                forcedEnabledMode="true" [isRequired]="false" [min]="minDate" [max]="maxDate"
                [(text)]="kymw1501Model.fileRegistDateTo" [tabindex]="0"></wj-input-date>
              <button class="btn-tartiary" forcedEnabledMode="true" id="btn_FileRegistDateClear"
                (click)="eventFileRegistDateClear_CLICKHandler()" [tabindex]="0">クリア</button>
            </div>

            <label class="list-input-title">対象</label>
            <div class="list-input-content">
              <app-checkbox-label id="chk_FileNonRegistOnly" #chk_FileNonRegistOnly [subid]="'chk_FileNonRegistOnly'"
                label="マークファイル未登録のみ" [forcedEnabledMode]="'true'" [tabindex]="0"
                [(ngModel)]="kymw1501Model.fileNonRegistOnly">
              </app-checkbox-label>
              <app-checkbox-label id="chk_UnableOnly" #chk_UnableOnly [subid]="'chk_UnableOnly'" label="使用停止マークのみ"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw1501Model.unableOnly">
              </app-checkbox-label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" forcedEnabledMode="true" id="btn_GetMarkFile"
            (click)="eventGetMarkFile_CLICKHandler()" [tabindex]="0">検索</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>